import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { ServiceAreasHeroSection } from '@trashlab/sitesapp/src/templates/redebins/components/service-areas/service-areas-hero-section';
import { ServiceAreasContent } from '@trashlab/sitesapp/src/templates/redebins/components/service-areas/service-areas-content';
import { ReadyWhenYouAre } from '@trashlab/sitesapp/src/templates/redebins/components/shared/ready-when-you-are';
import { ServiceAreasSection } from '@trashlab/sitesapp/src/templates/redebins/components/shared/service-areas-section';

const ServiceAreasPage = () => {
  return (
    <>
      <ServiceAreasHeroSection />
      <ServiceAreasContent />
      <ReadyWhenYouAre />
      <ServiceAreasSection />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/service-areas',
  component: ServiceAreasPage,
});

